import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import { Documentation } from 'graphql-common';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import Chip from '@lib/components/Chip/Chip';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
// import UserChip from '@lib/components/UserChip/UserChip';
// import DocumentationValidationStatusChip from '@lib/components/DocumentationValidationStatusChip/DocumentationValidationStatusChip';
// import { getFormattedDate } from '@lib/utils/dateTimeHelpers';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import styles from '../DocumentView.module.scss';

type Props = {
  data: Documentation;
  isViewLocked: boolean;
};

type InfoItemProps = {
  icon: string;
  label: string;
  children: ReactNode;
};

function InfoItem({ icon, label, children }: InfoItemProps) {
  return (
    <div className={entityViewStyles.infoItem}>
      <p className={entityViewStyles.infoItemLabel}>
        <MaterialIcon icon={icon} symbolsOutlined />
        <Typography variant="caption">{label}</Typography>
      </p>
      <div className={entityViewStyles.infoItemContent}>{children}</div>
    </div>
  );
}

export default function DocumentInfo({ data, isViewLocked }: Props) {
  const { t } = useTranslation();
  const {
    // code,
    category,
    // createdAt,
    // updatedAt,
    // createdBy,
    // approver,
    // validationStatus,
  } = data;

  return (
    <div className={styles.infoSection}>
      {/* <InfoItem icon="password" label={t('code')}>
        <Typography variant="body">{code || '-'}</Typography>
      </InfoItem> */}

      {!isViewLocked && (
        <InfoItem icon="category" label={t('category')}>
          {category ? (
            <Chip
              type={colorToChipType(_get(category, 'color'))}
              label={_get(category, 'name')}
              leftIcon="circle"
            />
          ) : (
            <Typography variant="body">-</Typography>
          )}
        </InfoItem>
      )}

      {/* {!isViewLocked && validationStatus && (
        <InfoItem icon="verified_user" label={t('validation')}>
          <DocumentationValidationStatusChip documentation={data} />
        </InfoItem>
      )} */}

      {/* <InfoItem icon="calendar_today" label={t('date-created')}>
        <Typography variant="body">{getFormattedDate(createdAt)}</Typography>
      </InfoItem> */}

      {/* <InfoItem icon="update" label={t('last-updated')}>
        <Typography variant="body">{getFormattedDate(updatedAt)}</Typography>
      </InfoItem> */}

      {/* {createdBy && (
        <InfoItem icon="person_edit" label={t('created-by')}>
          <UserChip user={createdBy as User} />
        </InfoItem>
      )} */}

      {/* {!isViewLocked && approver && (
        <InfoItem icon="how_to_reg" label={t('approver')}>
          <UserChip user={approver as User} />
        </InfoItem>
      )} */}
    </div>
  );
}
